import { all } from 'redux-saga/effects'

import { watchUserLoginAsync } from "./datalog";
import {
	watchFetchHeDataLogsListRequest,
	watchFetchHeDataLogFileRequest,
	watchFetchHeDataLogsListSucceeded,
	watchFetchMultipleHeDataLogFilesRequest,
	watchFetchMultipleHeDataLogFilesSucceeded,
	watchFetchMultipleHeDataLogFilesFailed,
	watchSetChartsXRange
} from "./he_data_logs"
import { watchConfigChartsSetDataSource } from "./charts"

export function* rootSaga() {
	yield all([
		watchUserLoginAsync(),
		watchFetchHeDataLogsListRequest(),
		watchFetchHeDataLogFileRequest(),
		watchFetchHeDataLogsListSucceeded(),
		watchFetchMultipleHeDataLogFilesRequest(),
		watchFetchMultipleHeDataLogFilesSucceeded(),
		watchFetchMultipleHeDataLogFilesFailed(),
		watchConfigChartsSetDataSource(),
		watchSetChartsXRange()
	]);
}